import { Box, styled, Grid } from "@mui/material"
import React, { useState, useRef, useEffect } from "react"
import SortingToggleIcon from "assets/icons/SortingToggleIcon.svg"
import AppTextField from "components/StyledComponents/AppTextField"
import ClearIcon from "@mui/icons-material/Clear"

const StyledTextField = styled(AppTextField)(({ theme }) => ({
  "& .MuiInputBase-input": {
    border: "none !important"
  },
  "& .MuiFilledInput-root": {
    border: `1px solid ${theme.palette.text.secondary} !important`,
    borderRadius: 6
  },
  "& .Mui-error": {
    borderColor: `${theme.palette.error.main} !important`,
    "& .MuiInputBase-input": {
      border: "none"
    }
  }
}))

const MatchingOptionTemplate = ({
  formik,
  index,
  dragStart,
  dragEnter,
  drop,
  arrayHelper,
  getOptionValues = () => {},
  getOptionPath = () => {}
}) => {
  const [questionText, setQuestionText] = useState("")
  const [answerText, setAnswerText] = useState("")
  const questionTimeoutRef = useRef(null)
  const answerTimeoutRef = useRef(null)
  const optionErrors = getOptionValues(formik?.errors)?.[index] || {}
  const optionTouched = getOptionValues(formik?.touched)?.[index] || {}

  const onQuestionTextChange = (e) => {
    const value = e.target.value
    setQuestionText(value)
    if (questionTimeoutRef.current) {
      clearTimeout(questionTimeoutRef.current)
    }

    questionTimeoutRef.current = setTimeout(
      () => formik.setFieldValue(`${getOptionPath()}.[${index}].name`, value),
      800
    )
  }

  const onQuestionTextBlur = (e) => {
    const value = e.target.value
    if (questionTimeoutRef.current) {
      clearTimeout(questionTimeoutRef.current)
      questionTimeoutRef.current = null
    }
    formik.setFieldValue(`${getOptionPath()}.[${index}].name`, value)
  }

  const onAnswerTextChange = (e) => {
    const value = e.target.value
    setAnswerText(value)
    if (answerTimeoutRef.current) {
      clearTimeout(answerTimeoutRef.current)
    }

    answerTimeoutRef.current = setTimeout(
      () => formik.setFieldValue(`${getOptionPath()}.[${index}].answer`, value),
      100
    )
  }

  const onAnswerTextBlur = (e) => {
    const value = e.target.value
    if (answerTimeoutRef.current) {
      clearTimeout(answerTimeoutRef.current)
      answerTimeoutRef.current = null
    }
    formik.setFieldValue(`${getOptionPath()}.[${index}].answer`, value)
  }

  useEffect(() => {
    return () => {
      if (questionTimeoutRef.current) {
        clearTimeout(questionTimeoutRef.current)
      }
      if (answerTimeoutRef.current) {
        clearTimeout(answerTimeoutRef.current)
      }
    }
  }, [])

  useEffect(() => {
    const option = getOptionValues(formik.values)?.[index]
    setQuestionText(option?.name || "")
    setAnswerText(option?.answer || "")
  }, [index, formik.values])

  return (
    <li
      key={`optionContainer-${index}`}
      style={{ listStyleType: "none", marginBottom: 20 }}
      className="optionItem"
      data-id={index}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={6}>
          <Box sx={{ maxWidth: "100%" }} className="d-flex">
            <Box
              className="d-flex justify-content-center align-items-start"
              sx={{ cursor: "grab", mr: 1 }}
              draggable
              onDragStart={(e) => dragStart(e, index)}
              onDragEnter={dragEnter}
              onDragEnd={() => drop(arrayHelper)}>
              <img src={SortingToggleIcon} alt="sort option" className="flex-shrink-0 mt-3" />
            </Box>
            <StyledTextField
              fullWidth
              placeholder={`Enter label for option-${index + 1}`}
              className="flex-shrink-1 flex-grow-1"
              error={optionTouched.name && Boolean(optionErrors.name)}
              helperText={optionTouched.name && optionErrors.name}
              InputProps={{
                disableUnderline: true
              }}
              value={questionText}
              onChange={onQuestionTextChange}
              onBlur={onQuestionTextBlur}
            />
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box sx={{ maxWidth: "100%" }} className="d-flex align-items-center">
            <StyledTextField
              fullWidth
              placeholder="Answer"
              className="flex-shrink-1 flex-grow-1 me-2"
              error={optionTouched.answer && Boolean(optionErrors.answer)}
              helperText={optionTouched.answer && optionErrors.answer}
              InputProps={{
                disableUnderline: true
              }}
              value={answerText}
              onChange={onAnswerTextChange}
              onBlur={onAnswerTextBlur}
            />
            {getOptionValues(formik.values).length > 1 ? (
              <span role="button" onClick={() => arrayHelper.remove(index)} className="ms-5">
                <ClearIcon sx={{ width: "30px", height: "30px" }} />
              </span>
            ) : null}
          </Box>
        </Grid>
      </Grid>
    </li>
  )
}

export default MatchingOptionTemplate
